import _styled from "styled-components";
import { useTranslation } from "@crehana/i18n";
import AppleIso from "@crehana/icons/logos/AppleIso";
import GooglePlayIso from "@crehana/icons/logos/GooglePlayIso";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, PrimaryButton } from "@crehana/ui";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AppsColumn = function AppsColumn(_ref) {
  var isDark = _ref.isDark,
    className = _ref.className;
  var _useTranslation = useTranslation('main-footer'),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Col, {
    sm: 4,
    md: 2,
    offset: {
      sm: 1,
      md: 0
    },
    nowrap: true,
    className: className,
    children: [/*#__PURE__*/_jsx("p", {
      className: "font-button mb-20 ".concat(isDark ? 'text-base-lighter' : 'text-base-dark'),
      children: t('FOOTER_DOWNLOAD', 'Descarga nuestra app')
    }), /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(PrimaryButton, {
        label: "Google play",
        href: "https://play.google.com/store/apps/details?id=com.crehana.android",
        leftIcon: {
          component: GooglePlayIso,
          size: 18
        },
        className: "w-full mb-8 ".concat(isDark ? 'bg-gray-main-dark-mode' : 'bg-base-dark')
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        label: "App Store",
        href: "https://itunes.apple.com/us/app/crehana/id1353031284",
        leftIcon: {
          component: AppleIso,
          size: 18
        },
        className: "w-full ".concat(isDark ? 'bg-gray-main-dark-mode' : 'bg-base-dark')
      })]
    })]
  });
};
export default AppsColumn;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-16w9e7i-0"
})(["\n          ", " {\n            width: 172px;\n          }\n        "], function (props) {
  return props.theme.breakpoints.up('sm');
});